import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';
import { login, logout } from '@/api/login';
import { getToken, setToken, removeToken, setRememberMe, setLanguage } from '@/utils/auth';
import store from '@/store';
import { getSelfInfo, RoleInfo } from '@/api/userCenter';
import { RolePermissions } from '@/api/baseDefine';

export interface IUserState {
  token: string;
  name: string;
  avatar: string;
  roleName: string;
  roleInfo: RoleInfo;
  phone: string;
  email: string;
  portrait: string;
}

// admin user info
export interface AdminUserInfo {

}
const defaultPremission: RolePermissions = {
  key: '',
  name: '',
  desc: '',
  permissions: [],
};

const defaultRoleInfo: RoleInfo = {
  root: false,
  frontPermissions: defaultPremission,
  backendPrmissions: defaultPremission,
};


@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token: string = '';
  public id: number = 0;
  public name: string = '';
  public phone: string = '';
  public email: string = '';
  public position: string = '';
  public companyName: string = '';
  public companyLogo: string = '';
  public zone: string = '';
  public companyMessageDate: number = 0;
  public companyPaymentDate: number = 0;
  public portrait: string = '';
  public avatar: string = '';
  public roleName: string = '';
  public frontRole: string = '';
  public language: string = '';
  public roleInfo: RoleInfo = { ...defaultRoleInfo };

  @Action
  public async Login(userInfo: { email: string, password: string, rememberMe: string, language: string, languageID: string }): Promise<boolean> {
    const email = userInfo.email.trim();
    const res: any = await login(email, userInfo.password, userInfo.languageID)
      .catch((err) => {
        console.error('d侧吃吃', err);
        removeToken();
        return false;
      });
    console.log(res)
    if (res.data && res.data.token) {
      setToken(res.data.token);
      setRememberMe(userInfo.rememberMe);
      setLanguage(userInfo.languageID);
      this.SetToken(res.data.token);
    } else {
      removeToken();
    }
    return !!res.data && !!res.data.token;
  }

  @Action({ commit: 'SET_TOKEN' })
  public async SetToken(token) {
    return token;
  }

  @Action({ commit: 'SET_TOKEN' })
  public async FedLogOut() {
    removeToken();
    return '';
  }

  @MutationAction({
    mutate: ['roleName', 'name', 'avatar', 'roleInfo', 'email', 'portrait', 'phone',
      'position', 'companyName', 'id', 'frontRole', 'language', 'companyLogo', 'companyMessageDate', 'companyPaymentDate', 'zone']
  })
  public async GetInfo() {
    const res = await getSelfInfo();
    if (res && res.data && res.data.userInfo) {
      return {
        roleName: res.data.userInfo.roleInfo.frontPermissions.name,
        name: res.data.userInfo.name,
        email: res.data.userInfo.email,
        position: res.data.userInfo.position,
        companyName: res.data.userInfo.companyName,
        portrait: res.data.userInfo.portrait,
        phone: res.data.userInfo.phone,
        avatar: res.data.userInfo.name,
        roleInfo: res.data.userInfo.roleInfo,
        id: res.data.userInfo.id,
        frontRole: res.data.userInfo.frontRole,
        language: res.data.userInfo.language,
        companyLogo: res.data.userInfo.companyLogo,
        companyMessageDate: res.data.userInfo.companyMessageDate,
        companyPaymentDate: res.data.userInfo.companyPaymentDate,
        zone: res.data.userInfo.zone,
      };
    } else {
      return {
        roleName: null,
        name: null,
        email: null,
        portrait: null,
        phone: null,
        id: null,
        avatar: null,
        roleInfo: null,
        position: null,
        companyName: null,
        frontRole: null,
        language: null,
        companyLogo: null,
        companyMessageDate: null,
        companyPaymentDate: null,
        zone: null,
      };
    }
  }

  @MutationAction({ mutate: ['token', 'roleName', 'roleInfo'] })
  public async LogOut() {
    if (getToken() === undefined) {
      throw Error('LogOut: token is undefined!');
    }
    await logout();
    removeToken();
    return {
      token: '',
      roleName: '',
      roleInfo: { ...defaultRoleInfo },
    };
  }

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;
  }
}

export const UserModule = getModule(User);
